import angular from 'angular'

import './vd-id-badge/vd-id-badge-title/vd-id-badge-title'

import IdBadgeComponent from './vd-id-badge/vd-id-badge.component'
import UserBadgeComponent from './vd-user-badge/vd-user-badge.component'
import VdCustomerBadgeComponent from './vd-customer-badge/vd-customer-badge.component'
import VdProductBadgeComponent from './vd-product-badge/vd-product-badge.component'

angular
  .module('vend.ui')
  .component('vdIdBadge', IdBadgeComponent)
  .component('vdUserBadge', UserBadgeComponent)
  .component('vdCustomerBadge', VdCustomerBadgeComponent)
  .component('vdProductBadge', VdProductBadgeComponent)
